import axios from 'axios';
import { savePreSigninLocation } from './signin-redirect';

export const fetch = async (url, method, params, callback, errorCallback = null, isFileUploadForm = false, cancelToken = null, retries = 0, options = {}) => {
  let headers = {};

  if (params == null) {
    params = {};
  }
  if (window.localStorage.getItem("jwt") != null) {
    headers["common"] = {
      Authorization: 'Bearer ' + window.localStorage.getItem('jwt')
    };
  }

  if (isFileUploadForm) {
    headers['Content-Type'] = 'multipart/form-data';
  }

  try {
    const axiosConfig = {
      method: method,
      url: process.env.REACT_APP_API_URL + url,
      data: method === "DELETE" && options.queryOnly ? undefined : params,
      params: (method === "GET" || method === "DELETE") ? params : null,
      headers: headers,
      cancelToken: cancelToken
    };
    // Support streamed binary PDF: responseType 'blob' for 200 + Content-Type: application/pdf
    if (options.responseType) {
      axiosConfig.responseType = options.responseType;
    }
    const response = await axios(axiosConfig);

    if (response.data === "INTERNAL_ERROR") {
      throw new Error(response);
    }

    if (callback) {
      callback(response);
    }
  } catch (e) {
    if(e?.response?.status === 406) {
      window.localStorage.removeItem("jwt");
      savePreSigninLocation();
      window.location.href = "/signin";
    }
    if (errorCallback) {
      errorCallback(e);
    } else {
      if (e.response === undefined || (e.response.status !== 401 && e.response.status !== 400)) {
        //console.error(e);
      }
    }
  }
};